import { createRequestTypes } from 'common/websocket-redux';

export const GET_CARRIER_AUDITS_REPORT = createRequestTypes(
  'admin/employer-reports/GET_CARRIER_AUDITS_REPORT',
);

export const GET_AUDIT_FLOWS = createRequestTypes(
  'admin/employer-reports/GET_AUDIT_FLOWS',
);
